import { useId } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';

import LoginForm from "~/components/LoginForm";
import Loader from "~/components/Loader";
import { userStore } from "~/stores/user";
import { trans } from "~/utils/trans";
import { ROUTES } from "~/const";

import "./style.less";

interface IAccessGate {
	// login = neprihlaseny uzivatel, permission = prihlaseny bez opravneni (administrace)
	reason: "login" | "permission";
}

// zluty zamek, zluta jako zaplacene dny v kalendari (stejne jako ikona vystrahy v ConfirmModal)
function LockIcon() {
	const gradientId = `lockGradient${useId().replace(/[^a-zA-Z0-9]/gu, "")}`;

	return <svg className="accessGate__icon" viewBox="0 0 24 24" aria-hidden="true">
		<defs>
			<linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
				<stop offset="0" stopColor="#f3f9a6" />
				<stop offset="1" stopColor="#cbc634" />
			</linearGradient>
		</defs>
		<path d="M7.5 10.5V7.5a4.5 4.5 0 0 1 9 0v3" fill="none" stroke="#cbc634" strokeWidth="2.2" strokeLinecap="round" />
		<rect x="4" y="10" width="16" height="11.5" rx="3" fill={`url(#${gradientId})`} />
		<circle cx="12" cy="14.6" r="1.7" fill="#282828" />
		<rect x="11.15" y="15.2" width="1.7" height="3.4" rx="0.85" fill="#282828" />
	</svg>;
}

// misto obsahu stranky pro neprihlaseneho uzivatele nebo uzivatele bez opravneni
export default function AccessGate({
	reason,
} : IAccessGate) {
	const navigate = useNavigate();
	const authChecked = userStore(userState => userState.authChecked);

	// po nacteni stranky jeste nevime, jestli je uzivatel prihlaseny - neblikame prihlasovacim formularem
	if (!authChecked) {
		return <div className="accessGate accessGate--loading">
			<Loader />
		</div>;
	}

	if (reason === "permission") {
		return <div className="accessGate">
			<div className="accessGate__card">
				<LockIcon />
				<h1 className="accessGate__title">{trans("accessGate.forbiddenTitle")}</h1>
				<p className="accessGate__text">{trans("accessGate.forbiddenText")}</p>
				<div className="accessGate__buttons">
					<Button className="MyButton" onClick={() => navigate(ROUTES.schedule)} variant="contained">{trans("accessGate.back")}</Button>
				</div>
			</div>
		</div>;
	}

	return <div className="accessGate">
		<div className="accessGate__card">
			<LockIcon />
			<h1 className="accessGate__title">{trans("userPage.unauthorized")}</h1>
			<p className="accessGate__text">{trans("accessGate.loginText")}</p>
			{/* po prihlaseni se zmeni uzivatel ve store a stranka sama zobrazi svuj obsah */}
			<LoginForm />
			<div className="accessGate__links">
				<p>{trans("accessGate.noAccount")} <Link to={ROUTES.register}>{trans("accessGate.register")}</Link></p>
				<p>{trans("accessGate.noEmail")} <Link to={ROUTES.verify}>{trans("accessGate.verify")}</Link></p>
			</div>
		</div>
	</div>;
}
